import React, { ReactElement, useState } from "react";
import styles from "./style.module.scss";
import { IAccordionItem } from "../../../genericTypes/sharedTypes";
import DownArrow from "../icons/downArrow";
import UpArrow from "../icons/upArrow";
import Link from "@components/shared/linkNoPrefetch";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";

export default function FaqItem({
    item,
    className,
    faq,
}: {
    item: IAccordionItem;
    className?: string;
    faq?: boolean;
}): ReactElement {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const [opened, setOpen] = useState(false);

    return (
        <div>
            <div className={`${styles.faqItem} flex flex-col`}>
                <div
                    onClick={() => setOpen(!opened)}
                    className={`flex justify-between items-baseline cursor-pointer px-4 lg:px-5 py-2.5 ${
                        className ?? ""
                    }`}
                >
                    <div className="w-[90%]">
                        {faq ? item.question : item.title}
                    </div>
                    <span className="ml-3">
                        {opened ? <UpArrow /> : <DownArrow />}
                    </span>
                </div>

                <div
                    style={{ height: opened ? "auto" : 0 }}
                    className={`${
                        opened ? "block" : "hidden"
                    } px-4 lg:px-8 py-0 lg:py-2`}
                >
                    <p className="inline-block mb-5">
                        <span
                            className="lg:text-base text-sm"
                            dangerouslySetInnerHTML={{
                                __html: faq ? item.answer : item.content,
                            }}
                        />

                        {!faq && (
                            <Link
                                href={item.link}
                                className=" inline-block lg:text-sm text-xs"
                            >
                                {translate(
                                    translations,
                                    "several_general_showMoreWithDots",
                                )}
                            </Link>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
}
